import ProductsSellRegistration from './ProductsSellRegistration';

export default ProductsSellRegistration;